// Page-walks a paged blustreamApi endpoint into one array.
export async function fetchAll(fetchPage) {
  const out = [];
  let page = 0;
  for (;;) {
    const res = await fetchPage(page);
    const content = (res && res.content) || [];
    out.push(...content);
    if (!res || !res.page || res.page.last || content.length === 0) break;
    page += 1;
  }
  return out;
}

// Data source, resolved per call: an explicit ?data=fixture|api wins; the no-auth
// /preview mirror and the test runner default to fixtures; everything else (the live
// /journeys app) defaults to real API data. Switch by reloading with the query param.
export function resolveTimelineSource() {
  try {
    const { search, pathname } = window.location;
    const query = new URLSearchParams(search).get('data');
    if (query === 'fixture' || query === 'fixtures') return 'fixtures';
    if (query === 'api') return 'api';
    if (pathname.startsWith('/preview')) return 'fixtures';
  } catch (e) { /* no window (test/SSR) — fall through */ }
  if (process.env.NODE_ENV === 'test') return 'fixtures';
  return 'api';
}

export const TIMELINE_SOURCE = resolveTimelineSource();
